'use strict';
import * as filterUtils from './filterUtils';
import {SortMethod} from './SortMethod';

module.exports = [
  '$provide',
  SortingDecorator];

function SortingDecorator($provide) {
  $provide.decorator('$filter', ['$delegate', decorateFilterService]);

  function decorateFilterService($delegate) {
    $delegate.toArray = filterUtils.toArray;
    $delegate.$naturalCompare = filterUtils.naturalCompare;
    $delegate.$sortByName = filterUtils.sortByName;
    $delegate.$sortByProperty = filterUtils.sortByProperty;
    $delegate.$sortByPropertyAccessor = filterUtils.sortByPropertyAccessor;
    $delegate.$filterWithToString = filterUtils.filterWithToString;
    $delegate.$filterByProperty = filterUtils.filterByProperty;
    $delegate.$replaceArrayContents = filterUtils.replaceArrayContents;
    $delegate.$combineLists = filterUtils.combineLists;

    Object.defineProperty($delegate, 'SORT_METHODS', {
      value: {
        ASCENDING: SortMethod.ASCENDING,
        DESCENDING: SortMethod.DESCENDING,
        NONE: SortMethod.NONE,
      }
    });

    Object.defineProperty($delegate.SORT_METHODS, 'getNext', {
      value: SortMethod.getNext,
    });

    return $delegate;
  }
}



// WEBPACK FOOTER //
// ./src/js/core-utilities/filters/FilterSortingDecorator.js